import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
});

// A FormData body must be sent as multipart with a browser-computed boundary. The JSON
// default above would otherwise override it and the server would see no file (422 "field
// required"). Drop the content-type for FormData so axios/the browser set it correctly.
api.interceptors.request.use((config) => {
    if (typeof FormData !== "undefined" && config.data instanceof FormData && config.headers) {
        delete config.headers["Content-Type"];
        delete config.headers["content-type"];
    }
    return config;
});

export function formatApiError(err) {
    const detail = err?.response?.data?.detail;
    if (detail == null) return err?.message || "Something went wrong.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
